<section class="p-1 p-md-4">
  <div class="card">
    <div class="card-header bg-white">
      <h2>
        Preencha as informações de senha abaixo
      </h2>
    </div>
    <div class="card-body">
      <div>
        <label>Nome:</label>
        <div class="form-control disabled bg-light text-secondary border-0 mb-3">{{usuario.nome}}</div>
        <label>Login:</label>
        <div class="form-control disabled bg-light text-secondary border-0 mb-3">{{usuario.login}}</div>
      </div>
      <div class="pb-3">
        <label for="senha">Senha</label>
        <input id="senha" type="password"  [formControl]="form.controls.senha" class="form-control input-validate">
        <app-msg-erro [control]="form.controls.senha"></app-msg-erro>
      </div>
      <div class="pb-3">
          <label for="csenha">Confirmar Senha</label>
          <input id="csenha" [formControl]="form.controls.senhaConf" type="password" class="form-control input-validate">
          <app-msg-erro [control]="form.controls.senhaConf"></app-msg-erro>
        </div>
    </div>
    <div class="card-footer bg-white d-flex">
      <button (click)="cancelar()" class="btn btn-lg btn-secondary mr-4">
        Cancelar
      </button>
      <button [disabled]="this.form.invalid" (click)="sendForm()" class="btn w-100 btn-success btn-lg">
        Confirmar
      </button>
    </div>
  </div>
</section>